import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2 d-flex"
}
const _hoisted_2 = {
  key: 0,
  class: "pr-1 w-50"
}
const _hoisted_3 = { class: "flex-fill" }

import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import TextInputWithVariables from "~/cabinet/vue/interface/tinymce/TextInputWithVariables.vue";
import {getSearchModesData} from "~/cabinet/vue/client/events/action/types/dataProvider/entity/EntityActionHelper";
import {useActionBlockFormProps} from "~/cabinet/vue/client/events/action/types/useActionBlockForm";
import AbstractDataProviderEntityActionDescription
    from "~/cabinet/ts/data/events/actionDescriptions/DataProvider/AbstractDataProviderEntityActionDescription";
import {
    AbstractDataProviderEntityActionParamInterface, SEARCH_TYPE_VALUE_TYPE_FIELD, SEARCH_TYPE_VALUE_TYPE_STATIC
} from "~/cabinet/vue/client/events/action/types/dataProvider/AbstractDataProviderActionParamInterface";
import {computed, nextTick, PropType} from "vue";
import toggleSearchType from "~/cabinet/vue/client/events/action/types/dataProvider/entity/toggleSearchType";
import Dictionary from "~/ts/library/Dictionary";
import {
    DataProviderEntityFieldInterface
} from "~/cabinet/vue/client/events/action/types/dataProvider/entity/save/DataProviderEntitySaveActionParamInterface";
import {
    DataProviderEntitySaveSearchModeInterface
} from "~/cabinet/ts/data/events/actionDescriptions/DataProvider/Interface";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "SearchTypeConfig"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useActionBlockFormProps<AbstractDataProviderEntityActionDescription<AbstractDataProviderEntityActionParamInterface>>(),
    model: {
        type: Object as PropType<AbstractDataProviderEntityActionParamInterface>,
        required: true
    },
    fields: {
        type: Array as PropType<DataProviderEntityFieldInterface[]>
    }
},
  setup(__props) {

let props = __props;

let isFieldsAvailable = computed(() => Array.isArray(props.fields));

if (!isFieldsAvailable.value) {
    for (let typeId in props.model.searchTypes) {
        if (props.model.searchTypes.hasOwnProperty(typeId)) {
            let searchType = props.model.searchTypes[typeId];
            if (searchType.valueTypeId === SEARCH_TYPE_VALUE_TYPE_FIELD) {
                searchType.valueTypeId = SEARCH_TYPE_VALUE_TYPE_STATIC;
            }
        }
    }
}

let {otherSearchTypes} = getSearchModesData(props);

let addTime: Dictionary<number> = {};


function addSearchType(searchType: DataProviderEntitySaveSearchModeInterface) {
    addTime[searchType.id] = Date.now();
    toggleSearchType(props.model, searchType, isFieldsAvailable.value, true)
}

function removeSearchType(searchType: DataProviderEntitySaveSearchModeInterface) {
    nextTick(() => toggleSearchType(props.model, searchType, isFieldsAvailable.value, false))
}

let displayedOtherSearchTypes = computed(() => {
    return otherSearchTypes.value.filter(type => {
        return !!props.model.searchTypes[type.id]?.enabled || type.isDefault;
    }).sort((a, b) => {
        let time1 = a.isDefault ? null : addTime[a.id];
        let time2 = b.isDefault ? null : addTime[b.id];
        if (time1 && time2) {
            return time1 < time2 ? -1 : 1;
        } else if (time1) {
            return 1;
        } else if (time2) {
            return -1;
        } else {
            return 0;
        }
    });
});

let availableToAdd = computed(() => {
    return otherSearchTypes.value.filter(type => !displayedOtherSearchTypes.value.includes(type));
});

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedOtherSearchTypes), (searchType) => {
      return (_openBlock(), _createBlock(ElCardSection, {
        key: searchType.id
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_switch, {
            "model-value": __props.model.searchTypes[searchType.id]?.enabled ?? false,
            "onUpdate:modelValue": ($event: any) => ($event ? addSearchType(searchType) : removeSearchType(searchType)),
            class: "mr-2"
          }, null, 8, ["model-value", "onUpdate:modelValue"]),
          _createTextVNode(" " + _toDisplayString(searchType.descr) + " ", 1),
          (__props.model.searchTypes[searchType.id]?.enabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(isFieldsAvailable))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_el_select, {
                        modelValue: __props.model.searchTypes[searchType.id].valueTypeId,
                        "onUpdate:modelValue": ($event: any) => ((__props.model.searchTypes[searchType.id].valueTypeId) = $event)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            value: _unref(SEARCH_TYPE_VALUE_TYPE_FIELD),
                            label: "Значение поля из формы"
                          }, null, 8, ["value"]),
                          _createVNode(_component_el_option, {
                            value: _unref(SEARCH_TYPE_VALUE_TYPE_STATIC),
                            label: "Задать значение вручную"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onUpdate:modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                  (__props.model.searchTypes[searchType.id].valueTypeId == _unref(SEARCH_TYPE_VALUE_TYPE_STATIC))
                    ? (_openBlock(), _createBlock(TextInputWithVariables, {
                        key: 0,
                        modelValue: __props.model.searchTypes[searchType.id].value,
                        "onUpdate:modelValue": ($event: any) => ((__props.model.searchTypes[searchType.id].value) = $event),
                        multiline: false,
                        "content-variables": _unref(props).contentVariables,
                        placeholder: "Укажите значение для поиска"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "content-variables"]))
                    : (__props.model.searchTypes[searchType.id].valueTypeId == _unref(SEARCH_TYPE_VALUE_TYPE_FIELD))
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 1,
                          modelValue: __props.model.searchTypes[searchType.id].fieldId,
                          "onUpdate:modelValue": ($event: any) => ((__props.model.searchTypes[searchType.id].fieldId) = $event),
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                value: field.id,
                                label: field.descr
                              }, null, 8, ["value", "label"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1024))
    }), 128)),
    (_unref(availableToAdd).length)
      ? (_openBlock(), _createBlock(ElCardSection, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown, {
              trigger: "click",
              onCommand: _cache[0] || (_cache[0] = ($event: any) => (addSearchType(_unref(availableToAdd).find(item => item.id == $event))))
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableToAdd), (type) => {
                      return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: type.id,
                        command: type.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(type.descr), 1)
                        ]),
                        _: 2
                      }, 1032, ["command"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, { link: "" }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Добавить способ поиска ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})